import React from 'react'
import { ControlledInput } from "../../common/Input/Input";
import { ArrowLeft, Info } from 'react-feather';
import Select from "react-select";
import { toast } from 'react-toastify'


const ServiceFields = (props) => {

    // console.log("Props", props.serviceFields)
    return (
        <div>
            <span style={{ cursor: "pointer" }} onClick={props.BackPage}>
                <ArrowLeft style={{ marginRight: "10px" }} />
            </span>
            <label>
                <b>Edit Catalogue</b>
            </label>
            <div className="row mt-2">
                <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Catalogue ID <span className="required">*</span></label>
                    <span style={{ cursor: "pointer" }} title={"For Eg :- BUSINESSPLAN_DIY_No_Payment_Deasra"}>
                        <Info style={{ marginLeft: "10px", width: "15px" }} />
                    </span>
                    <br />
                    <ControlledInput
                        name="sCatalogueId"
                        placeholder="Catalogue Id"
                        value={props.serviceFields.sCatalogueId || ""}
                        onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                        autoComplete="off"
                    />
                </div>

                <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Service Code <span className="required">*</span></label><br />
                    <Select
                        options={props.serviceCodeOptions}
                        onChange={props.onServiceCodeChange}
                        value={props.selectedServiceCode}
                    />
                </div>

                <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Delivery Mode <span className="required">*</span></label><br />
                    <Select
                        options={props.deliveryMode}
                        onChange={props.onDeliveryModeChange}
                        value={props.selectedDeliveryMode}
                    />
                </div>

            </div>

            <div className="row">
                <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Payment Mode <span className="required">*</span></label><br />
                    <Select
                        options={props.paymentOption}
                        onChange={props.onPaymentChange}
                        value={props.selectedPaymentType}
                    />
                </div>



                <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Payment Receiver <span className="required">*</span></label><br />
                    {/* <Select
                        options={props.paymentReceiver}
                        onChange={props.onPaymentReceiverChange}
                        value={props.selectedPaymentReceiver}
                    /> */}

                    <Select
                        options={props.paymentReceiver}
                        onChange={props.onPaymentReceiverChange}
                        // value={props.selectedPaymentReceiver}
                        value={props.selectedPaymentType.value === "No_Payment" ? "" : props.selectedPaymentReceiver}
                        isDisabled={props.selectedPaymentType.value === "No_Payment" ? true : false}
                    />
                </div>

                <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Mode <span className="required">*</span></label><br />
                    {/* <Select
                        options={props.mode}
                        onChange={props.onModeChange}
                        value={props.selectedMode}
                    /> */}

                    <Select
                        options={props.mode}
                        onChange={props.onModeChange}
                        // value={props.selectedMode}
                        value={props.selectedPaymentType.value === "No_Payment" ? "" : props.selectedMode}
                        isDisabled={props.selectedPaymentType.value === "No_Payment" ? true : false}
                    />
                </div>

            </div>

            <div className="row mt-3">

                {
                    props.selectedPaymentType.value === "No_Payment" || props.selectedMode.value === "DYNAMIC_DeAsraDriven" || props.selectedMode.value === "DYNAMIC_UserDriven" || props.selectedMode.value === "DYNAMIC_PartnerDriven" ?
                        <div className="col-4">
                            <label style={{ marginBottom: "10px" }}>Amount First</label><br />
                            <ControlledInput
                                className="w-50"
                                name="fAmountFirst"
                                placeholder="Amount First"
                                value={"0"}
                                onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                                onKeyDown={(e) => {
                                    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
                                    if (
                                        !/^\d$/.test(e.key) &&
                                        !allowedKeys.includes(e.key) &&
                                        e.key !== "Tab"
                                    ) {
                                        e.preventDefault();
                                    }
                                }}
                                autoComplete="off"
                                readOnly
                            />
                        </div>
                        :
                        <div className="col-4">
                            <label style={{ marginBottom: "10px" }}>Amount First</label><br />
                            <ControlledInput
                                className="w-50"
                                name="fAmountFirst"
                                placeholder="Amount First"
                                value={props.serviceFields.fAmountFirst === 0 ? "0" : props.serviceFields.fAmountFirst}
                                onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                                onKeyDown={(e) => {
                                    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
                                    if (
                                        !/^\d$/.test(e.key) &&
                                        !allowedKeys.includes(e.key) &&
                                        e.key !== "Tab"
                                    ) {
                                        e.preventDefault();
                                    }
                                }}
                                autoComplete="off"
                            />
                        </div>
                }

                {
                    props.selectedPaymentType.value === "No_Payment" || props.selectedPaymentType.value === "1_Step_Payment" || props.selectedMode.value === "DYNAMIC_DeAsraDriven" || props.selectedMode.value === "DYNAMIC_UserDriven" || props.selectedMode.value === "DYNAMIC_PartnerDriven" ?
                        <div className="col-4">
                            <label style={{ marginBottom: "10px" }}>Amount Second</label><br />
                            <ControlledInput
                                className="w-50"
                                name="fAmountSecond"
                                placeholder="Amount Second"
                                value={"0"}
                                onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                                onKeyDown={(e) => {
                                    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
                                    if (
                                        !/^\d$/.test(e.key) &&
                                        !allowedKeys.includes(e.key) &&
                                        e.key !== "Tab"
                                    ) {
                                        e.preventDefault();
                                    }
                                }}
                                autoComplete="off"
                                readOnly
                            />
                        </div>
                        :
                        <div className="col-4">
                            <label style={{ marginBottom: "10px" }}>Amount Second</label><br />
                            <ControlledInput
                                className="w-50"
                                name="fAmountSecond"
                                placeholder="Amount Second"
                                value={props.serviceFields.fAmountSecond === 0 ? "0" : props.serviceFields.fAmountSecond}
                                onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                                onKeyDown={(e) => {
                                    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
                                    if (
                                        !/^\d$/.test(e.key) &&
                                        !allowedKeys.includes(e.key) &&
                                        e.key !== "Tab"
                                    ) {
                                        e.preventDefault();
                                    }
                                }}
                                autoComplete="off"
                            />
                        </div>
                }



                {/* <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Amount Full </label><br />
                    <ControlledInput
                    className="w-50"
                        name="fAmountFull"
                        placeholder="Amount Full"
                        value={props.serviceFields.fAmountFull === 0 ? "0" : props.serviceFields.fAmountFull}
                        onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                        onKeyDown={(e) => {
                            const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
                            if (
                                !/^\d$/.test(e.key) &&
                                !allowedKeys.includes(e.key) &&
                                e.key !== "Tab"
                            ) {
                                e.preventDefault();
                            }
                        }}
                        autoComplete="off"
                    />
                </div> */}

                <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>GST Percentage </label><br />
                    {/* <Select
                        className="w-50"
                        options={props.GSTPercentageOptions}
                        onChange={props.onGstPercentChange}
                        value={props.selectedGSTPercentageOption}
                    /> */}

                    <Select
                        className="w-50"
                        options={props.GSTPercentageOptions}
                        onChange={props.onGstPercentChange}
                        // value={props.selectedGSTPercentageOption}
                        value={props.selectedPaymentType.value === "No_Payment" ? "0" : props.selectedGSTPercentageOption}
                        isDisabled={props.selectedPaymentType.value === "No_Payment" ? true : false}
                    />
                </div>


            </div>

            <div className="row mt-2">

                <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Expected TAT </label><br />
                    {/* <ControlledInput
                        className="w-50"
                        name="nExpectedTAT"
                        placeholder="Expected TAT"
                        value={(props.serviceFields.nExpectedTAT === null || props.serviceFields.nExpectedTAT === 0) ? "0" : props.serviceFields.nExpectedTAT}
                        onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                        onKeyDown={(e) => {
                            const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
                            if (
                                !/^\d$/.test(e.key) &&
                                !allowedKeys.includes(e.key) &&
                                e.key !== "Tab"
                            ) {
                                e.preventDefault();
                            }
                        }}
                        autoComplete="off"
                    /> */}

                    <ControlledInput
                        className="w-50"
                        name="nExpectedTAT"
                        placeholder="Expected TAT"
                        // value={(props.serviceFields.nExpectedTAT === null || props.serviceFields.nExpectedTAT === 0) ? "0" : props.serviceFields.nExpectedTAT}
                        // onChange={({ target: { name, value } }) => props.handleChange(name, value)}

                        value={(props?.expectedTat == null || props.expectedTat === 0) ? "0" : props.expectedTat}

                        onChange={(e) => {
                            const value = e.target.value;

                            // Allow empty input or numeric value between 0 and 99 (1 or 2 digits only)
                            if (value === "" || (/^\d{1,2}$/.test(value) && Number(value) >= 0 && Number(value) <= 99)) {
                                props.handleExpectedTatChange(value);
                            } else {
                                toast("Please enter a number between 0 and 99", {
                                    autoClose: 5000,
                                    type: toast.TYPE.ERROR,
                                });
                            }
                        }}
                        onKeyDown={(e) => {
                            const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
                            if (
                                !/^\d$/.test(e.key) &&
                                !allowedKeys.includes(e.key) &&
                                e.key !== "Tab"
                            ) {
                                e.preventDefault();
                            }
                        }}
                        autoComplete="off"
                        disabled={props?.isExpectedTatDisabled}
                    />
                </div>

                <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Execution Owner </label><br />
                    <Select
                        className="w-50"
                        options={props.executionOwnerOptions}
                        onChange={props.onExecutionOwnerChange}
                        value={props.selectedExectionOwner}
                    />
                </div>
            </div>

            <div className="row mt-3">
                <div className="col">
                    <button className='my-services-model-submit-btn' onClick={props.onSaveClick}> Save</button>
                </div>
            </div>


        </div>
    )
}

export default ServiceFields
